'use strict';

var privatePropertyAccessor = require('../internal/privatePropertyAccessor');

module.exports = privatePropertyAccessor('utc');


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/var/_utc.js
// module id = 78
// module chunks = 0